import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8">
        <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-accent-400">
          <span className="h-px w-7 bg-accent-500" /> 分类导航
        </p>
        <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">按类整理，快速定位想追的番</h2>
        <p className="mt-2 max-w-xl text-sm text-foreground-600">
          无论是热血燃作还是治愈日常，都能在这里找到属于自己的分类，入口直达，追番不走弯路。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group relative overflow-hidden rounded-2xl bg-background-100 p-6 ring-1 ring-background-300/60 transition-all duration-300 hover:-translate-y-1 hover:ring-primary-500/60"
          >
            <span className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-primary-500/10 transition-transform duration-300 group-hover:scale-150" />
            <span className="relative flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-secondary-400 to-primary-500 text-background-50">
              <i className={`${c.icon} text-xl`} />
            </span>
            <h3 className="relative mt-4 font-heading text-lg text-foreground-950 group-hover:text-primary-400">
              {c.name}
            </h3>
            <p className="relative mt-1 text-xs text-foreground-600">{c.subtitle}</p>
            <p className="relative mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
              {c.description}
            </p>
            <span className="relative mt-4 flex items-center gap-1 text-xs font-bold text-primary-400 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              进入分类 <i className="ri-arrow-right-line" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}